import { FileCopy } from '@material-ui/icons';
import React, { useMemo, useState } from 'react';
import { IconButton, Popover, Typography } from '@material-ui/core';

import { TextField } from '../../components/AtomComponents';

import useDataService from '../../hooks/useDataService';

import { eMessageType } from '../../types/IMessageType';
import { IGroupedDevices, IGeneratedDevice } from './types';

interface ISerialNumberPopoverProps {
  anchor: HTMLElement | null;
  category: IGeneratedDevice['testCategory'] | null;
  group: IGroupedDevices[IGeneratedDevice['testCategory']];
  onClose: () => void;
}

const SerialNumberPopover: React.FC<ISerialNumberPopoverProps> = ({
  anchor,
  category,
  group,
  onClose,
}) => {
  const { openSnackBar } = useDataService();

  const [search, setSearch] = useState('');

  const filtered = useMemo(
    () => group.serialItems.filter((g) => g.serialId.toLowerCase().includes(search.toLowerCase())),
    [group, search]
  );

  const totalInCategory = group.totalCount;

  const onCopy = (d: typeof group['serialItems'][number]) => () => {
    navigator.clipboard.writeText(d.serialId);
    openSnackBar('Copied to clipboard', eMessageType.success);
  };

  const handleClose = () => {
    setSearch('');
    onClose();
  };

  return (
    <Popover
      open={Boolean(anchor)}
      anchorEl={anchor}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
      <div className="pxw-serial-popover">
        <Typography variant="subtitle2" className="pxw-serial-popover__title">
          {category} — {totalInCategory} devices
        </Typography>
        <TextField
          label="Search serial numbers"
          value={search}
          autoFocus
          className="margin-vertical-1"
          onChange={(e) => setSearch(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
        />
        <div className="pxw-serial-popover__list">
          {filtered.map((d) => (
            <div key={d.serialId} className="pxw-serial-popover__list-item">
              <Typography variant="body2" style={{ flex: 1 }}>
                {d.serialId}
                {!!d.isAutoGenerated && (
                  <span className="text-faded" style={{ fontSize: '0.8rem' }}>
                    {' '}
                    (Auto-Generated)
                  </span>
                )}
              </Typography>
              <IconButton size="small" title="Copy serial number" onClick={onCopy(d)}>
                <FileCopy fontSize="small" />
              </IconButton>
            </div>
          ))}
          {filtered.length === 0 && (
            <Typography variant="body2" color="textSecondary">
              No results
            </Typography>
          )}
        </div>
      </div>
    </Popover>
  );
};

export default SerialNumberPopover;
